module.exports = __webpack_public_path__ + "img/eye.bfb19962.svg";